var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-info"},[_c('div',{staticClass:"title"},[_vm._v(" "+_vm._s(_vm.title)+" ")]),_vm._l((_vm.elements),function(element,index){return _c('div',{key:index,staticClass:"elements"},[_vm._v(" "+_vm._s(element)+" ")])})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }